import { NavigateFunction, NavigateOptions } from "react-router";



let navigate: NavigateFunction;

export function setNavigator(navFn: NavigateFunction) {
  navigate = navFn;
}

export function navigateTo(path: string, options?: NavigateOptions) {
  if (!navigate) {
    console.warn('⚠️ navigate called before router initialized');
    return;
  }
  navigate(path, options);
}